import { FeatureDTO } from "./FeatureDTO";

export class DisableMyCoursesFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
